import React, { useState } from "react";
import InstallationModel from "../../core/models/Installation";
import {
  Theme,
  makeStyles,
  createStyles,
  withStyles,
  Tooltip,
  Typography,
  IconButton,
  AccordionSummary,
  Accordion,
  AccordionDetails,
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Toolbar,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { IEnumerable } from "../../core/models/ModelHelpers";
import { isArrayValid } from "../../helpers/utility";
import { useHubx, useHubXSubscribe } from "../../HubX";
import { EVENT_HOME_PAGE_SEARCH_CLICKED } from "../../Events";
import useConstructor from "../../core/hooks/useConstructor";
import { DEFAULT_MAX_ITEM_PER_PAGE } from "../../core/constants/appGlobals";
import { Workflow } from "../../core/models/Enum/Workflow";
import IPagination from "../../core/contracts/IPagination";
import useInfiniteScroll from "react-infinite-scroll-hook";
import { FETCH_BUSINESS_EVENTS } from "../../Fedx";
import BusinessEvent from "../../core/models/BusinessEvent";
import OrderingType from "../../core/models/OrderingType";
import IFilter from "../../core/contracts/IFilter";
import { Link, useHistory } from "react-router-dom";
import {
  BUSINESS_EVENT_STATUS_MAP,
  FREE_CUSTOMER,
  WAITING_APPROVAL_EMISSION,
  WAITING_CONFIRMATION_NO_EMISSION,
} from "../../core/models/EventStatus";
import SimpleLink from "../SimpleLink";
import { SessionCache } from "../../helpers/cache";

type ReportSimpleTableProps = {
  // header: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // rows: any[][];
  loading?: boolean;
};

// const history = useHistory();

const rowArray = [
  {
    id: "5342",
    cliente: "Luisa",
    data: "09/20/20",
    ultimoStatus: "Aguardando aprovação",
    abertoFechado: "Aberto",
    tipo: "Descarga Zero",
  },
  {
    id: "1234",
    cliente: "Isadora",
    data: "09/20/23",
    ultimoStatus: "Cobrança enviada ao CNC",
    abertoFechado: "Fechado",
    tipo: "Retenção Além do Tempo",
  },
];

const headerArray = [
  {
    id: "id",
    label: "Id",
    canSort: false,
  },
  {
    id: "customer",
    label: "Cliente",
    canSort: false,
  },
  {
    id: "dt_pedido",
    label: "Data do Evento",
    canSort: true,
  },
  {
    id: "status",
    label: "Último status",
    canSort: false,
  },
  {
    id: "openclosed",
    label: "Situação",
    canSort: false,
  },
  {
    id: "type",
    label: "Tipo",
    canSort: false,
  },
  {
    id: "details",
    label: "Detalhes",
    canSort: false,
  },
];

const initialQueryParams: IFilter = {
  pageSize: DEFAULT_MAX_ITEM_PER_PAGE,
  pageNumber: 1,
  orderByAscending: false,
  data: {
    id: "",
    client: "",
    isOpen: "",
    status: "",
    eventType: "",
  },
};

const loadingState = new Array(12).fill({});

// function TableNew({ header, rows, loading = false }: ReportSimpleTableProps) {
function TableNew({ loading = false }: ReportSimpleTableProps) {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      toolbarWrapper: {
        display: "flex",
        justifyContent: "flex-end",
        flex: 1,
        backgroundColor: "#fff",
      },
    })
  );

  const hub = useHubx();
  const history = useHistory();
  const classes = useStyles();

  // const [Orders, setOrders] = useState<Order[]>([]);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [pagination, setPagination] = useState<IPagination>({
    CurrentPage: 1,
    TotalPages: 0,
    PageSize: 0,
    TotalCount: 0,
  });
  const [loadingItems, setLoadingItems] = useState(false);
  const [orderBy, setOrderBy] = React.useState<string>("dt_pedido");
  const [ordering, setOrdering] = React.useState<OrderingType>("desc");
  const [appliedFilters, setAppliedFilters] = React.useState<IFilter>(initialQueryParams);
  const [businessEvents, setOrders] = useState<BusinessEvent[]>([]);

  const updateBusinessEventsList = async (filterObject: IFilter) => {
    const businessEventList = await hub.request(FETCH_BUSINESS_EVENTS, filterObject);
    setOrders(businessEventList.items);
    setPagination(businessEventList.pagination);
    setHasNextPage(
      businessEventList.pagination.CurrentPage < businessEventList.pagination.TotalPages
    );
  };

  useConstructor(() => {
    const cache = new SessionCache();
    const statusFilter = cache.get<string>("filter.status") || "";
    const isOpenFilter = cache.get<string>("filter.isopen") || "";
    const typeFilter = cache.get<string>("filter.type") || "";
    const clientFilter = cache.get<string>("filter.client") || "";
    const directoryFilter = cache.get<string>("filter.directory") || "";
    initialQueryParams.pageNumber = 1;
    initialQueryParams.data.status = !statusFilter || statusFilter == "all" ? "" : statusFilter;
    initialQueryParams.data.isOpen =
      !isOpenFilter || isOpenFilter === "all"
        ? ""
        : isOpenFilter === "Aberto"
        ? 0
        : isOpenFilter === "Fechado"
        ? 1
        : 2;
    initialQueryParams.data.eventType = !typeFilter || typeFilter == "all" ? "" : typeFilter;
    initialQueryParams.data.client = !clientFilter || clientFilter == "Todos" ? "" : clientFilter;
    initialQueryParams.data.directory =
      !directoryFilter || directoryFilter == "all" ? "" : directoryFilter;
    updateBusinessEventsList(initialQueryParams);
  });

  const [selectedOrderNumbers, setSelectedOrderNumbers] = useState<(IEnumerable | undefined)[]>([]);

  // const isSelected = user.id ? selectedOrderNumbers.includes(user.id) : selectedOrderNumbers.includes(user.email);

  const handleSearchButtonClicked = (filterObject: IFilter) => {
    setAppliedFilters(filterObject);
    updateBusinessEventsList(filterObject);
  };

  useHubXSubscribe(EVENT_HOME_PAGE_SEARCH_CLICKED, handleSearchButtonClicked);

  const handleSelectUser = (userId: IEnumerable | undefined) => {
    if (selectedOrderNumbers.includes(userId)) {
      return setSelectedOrderNumbers(selectedOrderNumbers.filter((x) => x !== userId));
    }

    return setSelectedOrderNumbers([...selectedOrderNumbers, userId]);
  };

  const selectedOrdersArrayIsValid = React.useMemo(() => isArrayValid(selectedOrderNumbers), [
    selectedOrderNumbers,
  ]);

  const areAllOrdersSelected = React.useMemo(() => {
    const allOrdersNumbers = rowArray.map((x) => x.id) ?? [];

    if (!selectedOrdersArrayIsValid || !isArrayValid(allOrdersNumbers)) {
      return false;
    }

    return allOrdersNumbers?.every((x) => allOrdersNumbers.includes(x));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrderNumbers]);

  const handleClickSelectAllUsers = () => {
    const allOrdersNumbers = rowArray.map((x) => x.id) ?? [];

    // Empty selection → select all
    if (!selectedOrdersArrayIsValid) {
      return setSelectedOrderNumbers(allOrdersNumbers);
    }

    // all users selected → deselect all
    if (areAllOrdersSelected) {
      return setSelectedOrderNumbers([]);
    }

    // some are selected → select all
    return setSelectedOrderNumbers(allOrdersNumbers);
  };

  const createSortHandler = (property: string) => {
    const isAsc = orderBy === property && ordering === "asc";
    const newOrdering = isAsc ? "desc" : "asc";
    setOrdering(newOrdering);
    setOrderBy(property);
    filterData(newOrdering);
  };

  const filterData = async (newOrdering: string) => {
    const filter = appliedFilters;
    filter.orderByAscending = newOrdering == "asc" ? true : false;
    filter.pageNumber = 1;
    setAppliedFilters(filter);
    updateBusinessEventsList(filter);
  };

  const onLoadMore = async () => {
    setLoadingItems(true);
    const filter = appliedFilters;
    filter.pageNumber = pagination.CurrentPage + 1;
    setAppliedFilters(filter);

    const result = await hub.request(FETCH_BUSINESS_EVENTS, filter);

    if (result) {
      const { items, pagination } = result;
      const newOrders = [...businessEvents, ...items];
      setOrders(newOrders);
      setLoadingItems(false);
      setPagination(pagination);
      setHasNextPage(pagination.CurrentPage < pagination.TotalPages);
    }
  };

  const infiniteRef = useInfiniteScroll({
    loading: loadingItems,
    hasNextPage,
    onLoadMore,
    scrollContainer: "window",
  });

  return (
    <>
      <Toolbar style={{ background: "#fff" }}>
        <div className={classes.toolbarWrapper}>
          <div>
            <Typography>{`Total de Registros: ${pagination?.TotalCount ?? "-"}`}</Typography>
          </div>
        </div>
      </Toolbar>
      <TableContainer style={{ height: "100%", width: "100%" }} component={Paper}>
        <Table stickyHeader style={{ width: "100%" }}>
          <TableHead style={{ backgroundColor: "#1D212A", textAlign: "left" }}>
            <TableRow>
              {headerArray.map((h, idx) => (
                <TableCell
                  align="left"
                  key={`${h.id}_header_${idx}`}
                  sortDirection={orderBy === h.id ? ordering : false}
                  style={{ backgroundColor: "#1D212A", color: "#fff" }}
                >
                  {h.canSort ? (
                    <TableSortLabel
                      active={orderBy === h.id}
                      direction={orderBy === h.id ? ordering : "asc"}
                      style={{ color: "#fff" }}
                      onClick={() => {
                        createSortHandler(h.id);
                      }}
                    >
                      <strong>{h.label}</strong>
                    </TableSortLabel>
                  ) : (
                    <strong>{h.label}</strong>
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody ref={infiniteRef as React.RefObject<HTMLTableSectionElement>}>
            {!loading &&
              // FIXME: ? to allow null, not sure about this
              businessEvents?.map((businessEvent, idx) => (
                <TableRow /* selected={isSelected}*/ key={`${businessEvent.id}_row_${idx}`}>
                  <TableCell align="left" key={`${businessEvent.id}_row_${idx}_col_`}>
                    {businessEvent.id}
                  </TableCell>
                  <TableCell align="left" key={`${businessEvent.numero_jde}_row_${idx}_col_`}>
                    {businessEvent.cliente
                      ? businessEvent.cliente.nome_fantasia
                      : (businessEvent.cliente_sap != null ? (businessEvent.cliente_sap.nome_fantasia ?? businessEvent.codigo_li) : businessEvent.numero_jde)}
                  </TableCell>
                  <TableCell align="left" key={`${businessEvent.created_at}_row_${idx}_col_`}>
                    {businessEvent.dt_protocolo_chegada_viagem_formatted}
                  </TableCell>
                  <TableCell align="left" key={`${"Ultimo Status"}_row_${idx}_col_`}>
                    {businessEvent.etapas_registradas.length
                      ? BUSINESS_EVENT_STATUS_MAP[
                          businessEvent.etapas_registradas[0].status_cobranca
                        ]
                      : " - "}
                  </TableCell>
                  <TableCell align="left" key={`${"Situacao"}_row_${idx}_col_`}>
                    {businessEvent.etapas_registradas.length
                      ? businessEvent.etapas_registradas[0].status_cobranca ===
                          WAITING_APPROVAL_EMISSION ||
                        businessEvent.etapas_registradas[0].status_cobranca ===
                          WAITING_CONFIRMATION_NO_EMISSION
                        ? "Aberto"
                        : businessEvent.etapas_registradas[0].status_cobranca === FREE_CUSTOMER
                        ? "Isento"
                        : "Fechado"
                      : " - "}
                  </TableCell>
                  <TableCell align="left" key={`${businessEvent.tipo_workflow}_row_${idx}_col_`}>
                    {Workflow[businessEvent.tipo_workflow]}
                  </TableCell>
                  <TableCell align="left" key={`${businessEvent.id} _row_${idx}_col_`}>
                    <SimpleLink href={`/event/${businessEvent.id}`} label="Link" />
                  </TableCell>
                </TableRow>
              ))}

            {loading &&
              loadingState.map((_, idx) => (
                <TableRow key={`_loading_row_${idx}`}>
                  <TableCell colSpan={headerArray.length}>
                    <Skeleton />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
export default TableNew;
